import { Box } from "@mui/material";
import { useState, useEffect } from "react";

const UserImage = ({ image, size = "150px", border = "none" }) => {
  const [imageError, setImageError] = useState(false);
  const [imageSrc, setImageSrc] = useState("/default-avatar.png");
  const projectId = process.env.REACT_APP_APPWRITE_PROJECT_ID;
  const appwriteEndpoint = process.env.REACT_APP_APPWRITE_ENDPOINT || "https://cloud.appwrite.io/v1";
  const appwriteBucketId = process.env.REACT_APP_APPWRITE_BUCKET_ID;
  const apiUrl = process.env.REACT_APP_API_URL || "https://my-pers-thing-server.onrender.com";
  
  useEffect(() => {
    // Reset error state when image prop changes
    setImageError(false);
    
    if (!image) {
      setImageSrc("/default-avatar.png");
      return;
    }
    
    try {
      // If the image is already an Appwrite URL, use it directly
      if (typeof image === 'string' && image.includes(appwriteEndpoint)) {
        setImageSrc(image);
        return;
      }
      
      // If the image is an Appwrite file ID
      if (appwriteBucketId && typeof image === 'string' && image.length > 10) {
        const appwriteUrl = `${appwriteEndpoint}/storage/buckets/${appwriteBucketId}/files/${image}/view?project=${projectId}&download=0`;
        setImageSrc(appwriteUrl);
        return;
      }
      
      // Fallback to direct URL if it's already a URL
      if (typeof image === 'string' && (image.startsWith("http") || image.startsWith("data:"))) {
        setImageSrc(image);
        return;
      }
      
      // Legacy path (for older images stored in assets)
      if (typeof image === 'string') {
        setImageSrc(`${apiUrl}/assets/${image}`);
        return;
      }
      
      // If nothing worked, use default
      setImageSrc("/default-avatar.png");
    } catch (error) {
      // console.error("Error processing image source:", error);
      setImageSrc("/default-avatar.png");
    }
  }, [image, appwriteEndpoint, appwriteBucketId, projectId, apiUrl]);

  // Handle image loading error
  const handleImageError = () => {
    // console.log("Image failed to load:", imageSrc);
    setImageError(true);
    setImageSrc("/default-avatar.png");
  };

  return (
    <Box
      width={size}
      height={size}
      sx={{
        border: border,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "#f0f0f0", // Background color while loading
      }}
    >
      <img
        style={{
          objectFit: "cover",
          width: "100%",
          height: "100%",
          display: "block"
        }}
        alt="user"
        src={imageError ? "/default-avatar.png" : imageSrc}
        onError={handleImageError}
      />
    </Box>
  );
};

export default UserImage;
